if (!customElements.get('product-spotify')) {
  customElements.define('product-spotify',
    class ProductSpotify extends HTMLElement {
      constructor() {
        super();  

        this.selectedItem = '';
        this.searchUrl = 'https://api.scaule.com/search?q=';    
        this.productUrl = 'https://api.scaule.com/product?q=';    
        this.codeUrl = 'https://api.scaule.com/code?q=';
      }
    
      connectedCallback() {        
        this.elements = {
          input: this.querySelector('input[type="text"]'),
          suggestions: this.querySelector('[data-suggestions]'),
          imageLabel: this.querySelector('[data-result-image-label]'),
          imageUrl: this.querySelector('input[type="hidden"]'),
          image: this.querySelector('[data-result-image]'),
        };
    
        this.setupEventListeners();
      }
    
      // Creates the event listeners
      setupEventListeners() {
        if (this.elements.input !== null) {
          this.elements.input.addEventListener('input', this.onInputChange.bind(this));
          this.elements.input.addEventListener('focus', this.onFocus.bind(this));
          //this.addEventListener('focusout', this.onFocusOut.bind(this));
          this.addEventListener('keydown', this.onKeydown.bind(this));
          this.addEventListener('keyup', this.onKeyup.bind(this));
        }
      }
    
      // On typing in the input
      async onInputChange(event) {   
        const query = this.elements.input.value;

        // Clear previous suggestions and image
        if (this.elements.suggestions !== null) this.elements.suggestions.innerHTML = '';

        if (query.length > 0) {
          const fetchUrl = `${this.searchUrl}${encodeURIComponent(query)}`;
          const response = await fetch(fetchUrl);
          const data = await response.json();

          // Display suggestions
          const items = [...data.albums, ...data.tracks, ...data.artists, ...data.playlists];
          
          items.forEach(item => {
              const div = document.createElement('div');            
              div.className = 'lbdb-customization-spotify-suggestion';

              if (item.image) {
                  const img = document.createElement('img');
                  img.src = item.image;
                  img.alt = item.name;             
                  div.appendChild(img);
              }

              const text = document.createElement('p');
              text.textContent = item.type + ": " + item.name;
              div.appendChild(text);
            
              div.addEventListener('click', () => {
                this.selectedItem = item;
                this.onSuggestionClick();
              });
              if (this.elements.suggestions !== null) this.elements.suggestions.appendChild(div);
          });
        } else {          
          if (this.elements.image) {
            this.elements.image.src = '';
            this.elements.image.style.display = 'none';
          }
        }
      }

      // When the search input is focused
      onFocus(event) {
        const query = this.elements.input.value;
    
        if (!query.length) return;
    
        this.onInputChange();
      }
    
      // When the search input is focused out
      onFocusOut(event) {
        setTimeout((event) => {
          if (!this.contains(document.activeElement) && !this.elements.suggestions.contains(document.activeElement)) this.close();
        })
      }

      // When a key is pressed
      onKeydown(event) {
        // Prevent the cursor from moving in the input when using the up and down arrow keys
        if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
          event.preventDefault();
        }
      }
    
      // When a key is released
      onKeyup(event) {
        const query = this.elements.input.value;
        if (!query.length) this.close();
        event.preventDefault();
    
        switch (event.code) {
          case 'ArrowUp':
            this.switchOption('up')
            break;
          case 'ArrowDown':
            this.switchOption('down');
            break;
          case 'Enter':
            //this.onSuggestionClick();
            break;
        }
      }

      // On clicking on a suggestion
      async onSuggestionClick(event) {        
        if (this.selectedItem) {
          if (this.elements.input !== null) this.elements.input.value = this.selectedItem.type + " : " + this.selectedItem.name;
          if (this.elements.suggestions !== null) this.elements.suggestions.innerHTML = '';
          
          console.log(`${this.productUrl}${this.selectedItem.id}`);

          const codeUrl = `${this.codeUrl}${this.selectedItem.id}`;
          const response = await fetch(codeUrl);
          const blob = await response.blob();
          const imageUrl = URL.createObjectURL(blob);

          if (this.elements.imageLabel) this.elements.imageLabel.style.display = 'block';
          if (this.elements.imageUrl) this.elements.imageUrl.value = codeUrl;
          if (this.elements.image) {
            this.elements.image.src = imageUrl;
            this.elements.image.style.display = 'block';
          }
        } else {
          alert('Veuillez sélectionner un élément parmi les suggestions.');
        }
      }

      // Closes the searchs results
      close() {
        if (this.elements.suggestions !== null) this.elements.suggestions.innerHTML = '';
      }

      // Navigates from a search result to another
      switchOption(direction) {
        const query = this.elements.input.value;
        if (!query.length) return;
    
        const moveUp = direction === 'up';
        const selectedElement = this.querySelector('[aria-selected="true"]');
    
        // Filter out hidden elements (duplicated page and article resources) thanks
        // to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
        const allVisibleElements = Array.from(
          this.querySelectorAll(".lbdb-customization-spotify-suggestion")
        ).filter((element) => element.offsetParent !== null);
        let activeElementIndex = 0;
    
        if (moveUp && !selectedElement) return;
    
        let selectedElementIndex = -1;
        let i = 0;
    
        while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
          if (allVisibleElements[i] === selectedElement) {
            selectedElementIndex = i;
          }
          i++;
        }
    
        if (!moveUp && selectedElement) {
          activeElementIndex =
            selectedElementIndex === allVisibleElements.length - 1
              ? 0
              : selectedElementIndex + 1;
        } else if (moveUp) {
          activeElementIndex =
            selectedElementIndex === 0
              ? allVisibleElements.length - 1
              : selectedElementIndex - 1;
        }
    
        if (activeElementIndex === selectedElementIndex) return;
    
        const activeElement = allVisibleElements[activeElementIndex];
    
        activeElement.setAttribute('aria-selected', true);
        if (selectedElement) selectedElement.setAttribute('aria-selected', false);
    
        this.elements.input.setAttribute('aria-activedescendant', activeElement.id);
      }
    }
  );
}